/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from "@/components-shared/ui/button";
import { cn } from "@/lib/utils";
import { ChevronDown } from "lucide-react";
import React, { RefObject, useEffect, useState } from "react";

const GoToLastMessage = ({
  msgsContainerRef,
}: {
  msgsContainerRef: RefObject<HTMLDivElement | null>;
}) => {
  const [scrollTop, setScrollTop] = useState(0);
  const [scrollHeight, setScrollHeight] = useState(0);

  const handleScroll = () => {
    setScrollTop(msgsContainerRef?.current?.scrollTop || 0);
    setScrollHeight(msgsContainerRef.current?.scrollHeight || 0);
  };

  useEffect(() => {
    msgsContainerRef.current?.addEventListener("scroll", handleScroll);
    return () => {
      msgsContainerRef.current?.removeEventListener("scroll", handleScroll);
    };
  }, [msgsContainerRef?.current?.scrollTop]);

  return (
    <Button
      variant={"ghost"}
      size={"icon"}
      aria-label="back to top button"
      onClick={() =>
        msgsContainerRef?.current?.scrollTo({
          top: msgsContainerRef.current?.scrollHeight,
          behavior: "smooth",
        })
      }
      className={cn(
        "hidden shadow-main rounded-full absolute bottom-16 rtl:left-10 ltr:right-10 bg-white z-[2] self-end",
        {
          flex: scrollHeight - scrollTop > 1000,
        }
      )}
    >
      <ChevronDown />
    </Button>
  );
};

export default GoToLastMessage;
